import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { PRIORITIES, qtyStep } from "@/lib/constants";

export function OrderScheduleFields({ form, set, unit }) {
  const step = qtyStep(unit);
  return (
    <>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label>Target Quantity{unit ? ` (${unit})` : ""}</Label>
          <Input type="number" min={step} step={step} value={form.target_quantity} onChange={(e) => set("target_quantity", e.target.value)} required data-testid="order-form-quantity" />
        </div>
        <div className="space-y-1.5">
          <Label>Priority</Label>
          <Select value={form.priority} onValueChange={(v) => set("priority", v)}>
            <SelectTrigger data-testid="order-form-priority"><SelectValue /></SelectTrigger>
            <SelectContent>
              {PRIORITIES.map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label>Start Date &amp; Time</Label>
          <Input type="datetime-local" value={form.start_date} onChange={(e) => set("start_date", e.target.value)} data-testid="order-form-start-date" />
        </div>
        <div className="space-y-1.5">
          <Label>Due Date &amp; Time</Label>
          <Input type="datetime-local" value={form.due_date} onChange={(e) => set("due_date", e.target.value)} required data-testid="order-form-due-date" />
        </div>
      </div>
    </>
  );
}
